import React, { Fragment } from 'react';
import R from 'ramda';
import PropTypes from 'prop-types';
import IconButton from '@cotyorg/ccx-molecules/IconButton';
import IconLink from '@cotyorg/ccx-molecules/IconLink';

const isBreakpointMediumDown = ({ currentBreakpoint }) => (
  currentBreakpoint && (currentBreakpoint === 'medium' || currentBreakpoint.includes('small'))
);

const getOnCartLinkClick = ({ currentBreakpoint, toggleMiniCart, hasMiniCart }) => (e) => {
  // allow the link to navigate to cartLink on small breakpoints
  if (!isBreakpointMediumDown({ currentBreakpoint }) && hasMiniCart) {
    e.preventDefault();
    toggleMiniCart();
  }
};

const HeaderActions = ({
  showSearch,
  showMiniCart,
  cartQuantity,
  searchLink,
  cartLink,
  onSearchClick,
  searchIconSrc,
  miniCartIconSrc,
  searchIconDataTest,
  searchButtonText = '',
  onMouseEnter,
  onMouseLeave,
  miniCart: MiniCart,
  toggleMiniCart,
  currentBreakpoint,
  searchIconWidth,
  searchIconHeight,
  miniCartIconWidth,
  miniCartIconHeight,
  iconLinkUrl,
  iconLinkImage,
  iconLinkImageAlt,
  shoppable: Shoppable,
}) => (
  <Fragment>
    {iconLinkUrl &&
      <IconLink
        testAttribute="icon-link"
        link={iconLinkUrl}
        iconSrc={R.prop('url', iconLinkImage)}
        iconAlt={iconLinkImageAlt}
        extraClass="header__icon-link"
      />
    }
    {showSearch &&
      (!!searchLink) ? (
        <IconLink
          testAttribute="search-icon-link-button"
          iconSrc={searchIconSrc}
          size="small"
          link={searchLink}
          extraClass="no-underline header__action-link"
          iconWidth={searchIconWidth}
          iconHeight={searchIconHeight}
        >
          <span className="show-for-sr">{ searchButtonText }</span>
        </IconLink>
      ) : (
        <IconButton
          testAttribute="search-icon-button"
          iconSrc={searchIconSrc}
          size="small"
          onClick={onSearchClick}
          extraClass="no-underline header__action-button"
          iconDataTest={searchIconDataTest}
          iconWidth={searchIconWidth}
          iconHeight={searchIconHeight}
        >
          <span className="show-for-sr">{ searchButtonText }</span>
        </IconButton>
      )
    }
    {showMiniCart &&
      <div
        className="header__action-link header__mini-cart-link-wrapper header__basket-link-wrapper"
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <IconLink
          testAttribute="mini-cart-button"
          link={cartLink}
          iconSrc={miniCartIconSrc}
          size="small"
          extraClass="no-underline header__mini-cart-link"
          textInside
          iconWidth={miniCartIconWidth}
          iconHeight={miniCartIconHeight}
          onClick={getOnCartLinkClick({
            currentBreakpoint,
            toggleMiniCart,
            hasMiniCart: !!MiniCart,
          })}
        >
          {cartQuantity > 0 && cartQuantity}
        </IconLink>

        {MiniCart && <MiniCart />}
      </div>
    }
    {Shoppable &&
      <div
        className="header__action-link header__shoppable-link-wrapper"
      >
        <Shoppable />
      </div>
    }
  </Fragment>
);

HeaderActions.propTypes = {
  showSearch: PropTypes.bool,
  showMiniCart: PropTypes.bool,
  cartQuantity: PropTypes.number,
  searchLink: PropTypes.string,
  cartLink: PropTypes.string,
  onSearchClick: PropTypes.func,
  searchIconSrc: PropTypes.string,
  miniCartIconSrc: PropTypes.string,
  searchIconDataTest: PropTypes.string,
  searchButtonText: PropTypes.string,
  miniCart: PropTypes.func,
  toggleMiniCart: PropTypes.func,
  currentBreakpoint: PropTypes.string,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  searchIconWidth: PropTypes.number,
  searchIconHeight: PropTypes.number,
  miniCartIconWidth: PropTypes.number,
  miniCartIconHeight: PropTypes.number,
  shoppable: PropTypes.func,
};

export default HeaderActions;
